export default __webpack_public_path__ + "static/button-app-store@2x-6380ae50cf357409bbb764c43a31137d.png";